import React from 'react';
import { Form } from 'antd';
import CustomerTextInput from '../../inputs/customerTextInput/CustomerTextInput';
import DefaultButton from '../../components/buttons/defaultButton/DefaultButton';
import CustomerPasswordInput from '../../inputs/customerPasswordInput/CustomerPasswordInput';
import useTranslation from '../../../hooks/translation/useTranslation';
import { useModal } from '../../../contexts/modalsContext/modalsContext';

function AuthorizeForm({
  form, handleSubmit, loading, errors,
}) {
  const { trans, configInfo } = useTranslation();
  const { setShowAuthModal, setShowPasswordRecovery } = useModal();

  const handleShowPasswordRecoveryModal = () => {
    setShowAuthModal(false);
    setShowPasswordRecovery(true);
  };

  const isGeorgia = configInfo?.countryCode === 'GE';
  return (
    <Form layout="vertical" form={form} onFinish={handleSubmit} className="flex flex-col gap-8 lg:gap-9">
      <div className="flex gap-4 flex-col lg:flex-row">
        <div className="lg:basis-1/2">
          <CustomerTextInput
            rules={[{
              required: true,
              message: trans('input_necessary'),
            }]}
            className="flex-1"
            name="email_or_phone_number"
            errorMessage={trans(errors?.email_or_phone_number)}
            label={`${trans('email')}${isGeorgia ? ` / ${trans('phone_number')}` : ''}`}
          />
        </div>
        <div className="lg:basis-1/2 flex flex-col">
          <CustomerPasswordInput
            rules={[{
              required: true,
              message: trans('input_necessary'),
            }]}
            className="flex-1"
            name="password"
            errorMessage={errors?.password}
            label={trans('password')}
          />
          <button
            onClick={handleShowPasswordRecoveryModal}
            type="button"
            className="bg-transparent border-none text-right text-xs text-black p-0"
          >
            {trans('forgot_password')}
            {' '}
            <span className="underline text-primary cursor-pointer ">
              {trans('password_recovery')}
            </span>
          </button>
        </div>
      </div>
      <div className="flex gap-4">
        <div className="basis-1/2 hidden lg:block" />
        <DefaultButton disabled={loading} type="submit" className="basis-full lg:basis-1/2 text-base leading-[22px]">{trans('login')}</DefaultButton>
      </div>
    </Form>
  );
}

export default AuthorizeForm;
